export default __webpack_public_path__ + "static/liquidity-icon-d5c0d6ff5291bec63b30425618f8cf2c.svg";